
(()=> {
  const btn = document.querySelector('[data-star-button]');
  const menu = document.querySelector('[data-star-menu]');
  const close = () => { if(!btn||!menu) return; menu.classList.remove('is-open'); btn.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); };
  const open  = () => { if(!btn||!menu) return; menu.classList.add('is-open'); btn.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); };
  if(btn && menu){
    btn.addEventListener('click', (e)=>{ e.preventDefault(); menu.classList.contains('is-open') ? close() : open(); });
    document.addEventListener('click', (e)=>{ if(!menu.contains(e.target) && !btn.contains(e.target)) close(); });
    document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') close(); });
  }

  const els = [...document.querySelectorAll('.reveal')];
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(ent=>{
      if(ent.isIntersecting){ ent.target.classList.add('is-visible'); io.unobserve(ent.target); }
    });
  }, {threshold: .12});
  els.forEach(el=>io.observe(el));

  const heroImg = document.querySelector('[data-parallax]');
  if(heroImg){
    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
    const on=()=>{
      const r=heroImg.getBoundingClientRect();
      const vh=window.innerHeight||800;
      const p=(r.top + r.height/2 - vh/2)/vh;
      heroImg.style.setProperty('--parallax', `${clamp(p*26,-26,26)}px`);
    };
    on(); window.addEventListener('scroll', on, {passive:true}); window.addEventListener('resize', on);
  }

  // --- Cart drawer + AJAX add-to-cart (Shopify native checkout stays intact) ---
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerBody = document.querySelector('[data-cart-body]');
  const drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  const popSubtotal = document.querySelector('[data-cart-subtotal]');
  const countEl = document.querySelector('[data-cart-count]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const closeBtns = [...document.querySelectorAll('[data-cart-close]')];

  const money = (cents) => {
    try{
      // If Shopify money format exists, just fallback to USD-like.
      const v = (cents/100);
      return v.toLocaleString(undefined,{style:'currency',currency:'USD'});
    }catch(e){ return `$${(cents/100).toFixed(2)}`; }
  };

  const fetchCart = async () => {
    const r = await fetch('/cart.js', {credentials:'same-origin'});
    if(!r.ok) throw new Error('cart fetch failed');
    return await r.json();
  };

  const setCount = (n) => {
    if(!countEl) return;
    countEl.textContent = n;
    countEl.style.display = n > 0 ? '' : 'none';
  };

  const openDrawer = () => {
    if(!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('no-scroll');
  };

  const closeDrawer = () => {
    if(!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('no-scroll');
  };

  closeBtns.forEach(b=>b.addEventListener('click', closeDrawer));
  if(cartToggle){
    cartToggle.addEventListener('click', (e)=>{ 
      // allow normal nav with modifier keys
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      openDrawer();
      refreshCartUI();
    });
  }

  const renderDrawer = (cart) => {
    if(drawerBody){
      if(cart.item_count === 0){
        drawerBody.innerHTML = `<div class="subtle" style="padding:16px 0;">Your cart is empty.</div>
          <a class="btn" href="/collections/all">Shop all products</a>`;
      } else {
        const items = cart.items.map((it, idx)=>{
          const variant = (it.variant_title && it.variant_title !== 'Default Title') ? `<div class="cart-mini-variant">${it.variant_title}</div>` : '';
          const img = it.image ? `<img src="${it.image}" alt="">` : '';
          return `
          <div class="cart-mini-item" data-line="${idx+1}">
            <a class="cart-mini-thumb" href="${it.url}">${img}</a>
            <div class="cart-mini-meta">
              <div class="cart-mini-title">${it.product_title}</div>
              ${variant}
              <div class="cart-mini-row">
                <div class="qty-pill">
                  <button type="button" class="qty-btn" data-line="${idx+1}" data-mini-minus aria-label="Decrease">−</button>
                  <input class="qty-input" type="number" min="0" value="${it.quantity}" data-line="${idx+1}" data-mini-qty>
                  <button type="button" class="qty-btn" data-line="${idx+1}" data-mini-plus aria-label="Increase">+</button>
                </div>
                <div style="font-weight:900;">${money(it.final_line_price)}</div>
              </div>
              <button type="button" class="cart-mini-remove" data-line="${idx+1}" data-mini-remove>Remove</button>
            </div>
          </div>`;
        }).join('');
        drawerBody.innerHTML = items;
      }
    }
    if(drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    if(popSubtotal) popSubtotal.textContent = money(cart.total_price);
    setCount(cart.item_count);
  };

  const wireDrawerControls = () => {
    if(!drawerBody) return;
    drawerBody.querySelectorAll('[data-mini-remove]').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const line = Number(btn.getAttribute('data-line'));
        await changeLine(line, 0);
      });
    });
    drawerBody.querySelectorAll('[data-mini-minus]').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const line = Number(btn.getAttribute('data-line'));
        const input = drawerBody.querySelector(`[data-mini-qty][data-line="${line}"]`);
        const q = Math.max(0, Number(input.value||0) - 1);
        await changeLine(line, q);
      });
    });
    drawerBody.querySelectorAll('[data-mini-plus]').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const line = Number(btn.getAttribute('data-line'));
        const input = drawerBody.querySelector(`[data-mini-qty][data-line="${line}"]`);
        const q = Number(input.value||0) + 1;
        await changeLine(line, q);
      });
    });
    drawerBody.querySelectorAll('[data-mini-qty]').forEach(input=>{
      input.addEventListener('change', async ()=>{
        const line = Number(input.getAttribute('data-line'));
        const q = Math.max(0, Number(input.value||0));
        await changeLine(line, q);
      });
    });
  };

  const refreshCartUI = async () => {
    try{
      const cart = await fetchCart();
      renderDrawer(cart);
      wireDrawerControls();
    }catch(e){
      // noop
    }
  };

  const addToCart = async (form) => {
    const fd = new FormData(form);
    const r = await fetch('/cart/add.js', {method:'POST', body: fd, headers:{'Accept':'application/json'}, credentials:'same-origin'});
    if(!r.ok) throw new Error('add failed');
    await refreshCartUI();
    openDrawer();
  };

  const changeLine = async (line, quantity) => {
    const r = await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({line, quantity})
    });
    if(!r.ok) throw new Error('change failed');
    const cart = await r.json();
    renderDrawer(cart);
    wireDrawerControls();
    // Also sync any cart page quantity inputs
    document.querySelectorAll(`[data-cart-qty][data-line="${line}"]`).forEach(inp=>{ inp.value = quantity; });
  };

  // Intercept add-to-cart on product form if button has data-ajax-add
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form=>{
    const btn = form.querySelector('[data-ajax-add]');
    if(!btn) return;
    form.addEventListener('submit', async (e)=>{
      e.preventDefault();
      btn.setAttribute('aria-busy','true');
      btn.style.opacity = '.8';
      try{ await addToCart(form); }
      catch(err){ form.submit(); } // fallback
      finally{
        btn.removeAttribute('aria-busy');
        btn.style.opacity = '';
      }
    });
  });

  // Cart page quantity + remove wiring
  document.querySelectorAll('[data-cart-remove]').forEach(btn=>{
    btn.addEventListener('click', async ()=>{
      const line = Number(btn.getAttribute('data-line'));
      await changeLine(line, 0);
      // reload cart page to re-render lines cleanly
      window.location.reload();
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach(input=>{
    input.addEventListener('change', async ()=>{
      const line = Number(input.getAttribute('data-line'));
      const q = Math.max(0, Number(input.value||0));
      await changeLine(line, q);
      window.location.reload();
    });
  });

  document.querySelectorAll('.cart-row [data-qty-minus]').forEach(btn=>{
    btn.addEventListener('click', async ()=>{
      const row = btn.closest('.cart-row');
      const input = row?.querySelector('[data-cart-qty]');
      if(!input) return;
      const line = Number(input.getAttribute('data-line'));
      const q = Math.max(0, Number(input.value||0) - 1);
      input.value = q;
      await changeLine(line, q);
      window.location.reload();
    });
  });

  document.querySelectorAll('.cart-row [data-qty-plus]').forEach(btn=>{
    btn.addEventListener('click', async ()=>{
      const row = btn.closest('.cart-row');
      const input = row?.querySelector('[data-cart-qty]');
      if(!input) return;
      const line = Number(input.getAttribute('data-line'));
      const q = Number(input.value||0) + 1;
      input.value = q;
      await changeLine(line, q);
      window.location.reload();
    });
  });

  // Initial cart UI for hover subtotal + count
  refreshCartUI();

})();

function closeWelcome(){
  document.getElementById("welcome-popup").style.display = "none";
  localStorage.setItem("welcomeClosed", "true");
}

function applyDiscount(e){
  e.preventDefault();
  window.location.href = "/discount/WELCOME10";
}

document.addEventListener("DOMContentLoaded", function(){
  if(!localStorage.getItem("welcomeClosed")){
    setTimeout(function(){
      document.getElementById("welcome-popup").style.display = "flex";
    }, 1200);
  }
});

function showDiscount(e){
  e.preventDefault();
  document.getElementById("welcome-form").style.display = "none";
  document.getElementById("discount-success").style.display = "block";
}

function closeWelcome(){
  document.getElementById("welcome-popup").style.display = "none";
  localStorage.setItem("welcomeClosed", "true");
}

document.addEventListener("DOMContentLoaded", function(){
  if(!localStorage.getItem("welcomeClosed")){
    setTimeout(function(){
      document.getElementById("welcome-popup").style.display = "flex";
    }, 1200);
  }
});

document.addEventListener("DOMContentLoaded", function(){

  const toggle = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("[data-mobile-menu]");
  const close = document.querySelector("[data-menu-close]");

  if(toggle){
    toggle.addEventListener("click", function(){
      menu.classList.add("open");
    });
  }

  if(close){
    close.addEventListener("click", function(){
      menu.classList.remove("open");
    });
  }

});

function switchImage(el){
  document.getElementById("active-image").src = el.src.replace("200x", "1000x");
}

function switchCartImage(index, newSrc){
  const main = document.getElementById("cart-main-" + index);
  if(main){
    main.src = newSrc;
  }
}
document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll(".thumb").forEach(function(thumb){

    thumb.addEventListener("click", function(){

      const newSrc = this.getAttribute("data-large");
      const main = document.getElementById("active-image");

      if(main && newSrc){
        main.src = newSrc;
      }

    });

  });

});